import { PageTitle } from 'components/common/PageTitle/PageTitle';
import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Button, Col, Result, Row, Skeleton } from 'antd';
import Contract from 'types/contract';
import { getOne } from 'api/contract.api';
import { EditContract } from 'components/employees/Contracts/EditContract';

const EditContractPage = () => {
  const params = useParams();
  const [contract, setContract] = useState<Contract | null>();
  const [loading, setLoading] = useState(false);
  const contractId = params.id;
  const navigate = useNavigate();

  const getContractDetail = useCallback(() => {
    if (contractId) {
      setLoading(true);
      getOne(contractId)
        .then((res) => {
          setContract(res.data);
          setLoading(false);
        })
        .catch(() => {
          setContract(null);
          setLoading(false);
        });
    }
  }, [contractId]);

  useEffect(() => {
    getContractDetail();
  }, [getContractDetail]);

  return (
    <>
      <PageTitle>{`Contrato - Detalle`}</PageTitle>
      {loading && (
        <Row>
          <Col xs={24}>
            <Skeleton active />
          </Col>
        </Row>
      )}
      {!loading && contract && <EditContract contract={contract} />}
      {!loading && !contract && (
        <Result
          status="error"
          title="Hubo un error al cargar el contrato del empleado"
          subTitle="Por favor vuelve a intentarlo más tarde."
          extra={[
            <Button type="primary" key="back" onClick={() => navigate(-1)}>
              Regresar
            </Button>,
            <Button key="reload" onClick={() => window.location.reload()}>
              Reintentar
            </Button>,
          ]}
        />
      )}
    </>
  );
};

export default EditContractPage;
